module.exports = __webpack_public_path__ + "img/05.5f5fe6e1.jpg";